import { render, staticRenderFns } from "./veSbzcZcAssetEdit.vue?vue&type=template&id=04ce3865&scoped=true"
import script from "./veSbzcZcAssetEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcZcAssetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce3865",
  null
  
)

export default component.exports